module.exports = __webpack_public_path__ + "img/icon-note.a45d6356.svg";